import { render, staticRenderFns } from "./team_setting.vue?vue&type=template&id=c6b52486&scoped=true&"
import script from "./team_setting.vue?vue&type=script&lang=js&"
export * from "./team_setting.vue?vue&type=script&lang=js&"
import style0 from "./team_setting.vue?vue&type=style&index=0&id=c6b52486&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b52486",
  null
  
)

export default component.exports